import React, { useState } from "react";
import "./header.scss";
import Button from "../Form/Button/Button";
import ButtonGroup from "../Form/Button/ButtonGroup";
import closeIcon from "../../assets/images/close.svg";
import hamburgerIcon from "../../assets/images/hamburger.svg";
import envConfig from "../../config/env-config";
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";
import env from "../../config/env";

/** @import {DashboardHeaderProps} from './DashboardHeaderTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */
/** @import {MultiProductHeaderLink} from './MultiProductHeaderTypes' */

/** @type {MultiProductHeaderLink[]} */
const primaryActions = [
  {
    text: "Log in",
    link: envConfig.links.loginLink,
  },
];

/** @type {MultiProductHeaderLink[]} */
const primaryActionsFaqs = [
  {
    text: "Log in",
    link: envConfig.links.loginLink,
  },
];

function MultiProductHeader(/** @type {DashboardHeaderProps & WithFeatureFlagsProps} */ props) {
  const [menuOpen, setMenuOpen] = useState(false);
  
  /** @type {MultiProductHeaderLink[]} */
  const multiSecondaryActions = [
    {
      text: "Online Flexi Saver",
      link: `${window.raeEnv.productPageUrl}/online-flexi-saver`,
      product: "ofs",
    },
    {
      text: "90-Day Notice Saver",
      link: `${window.raeEnv.productPageUrl}/notice-saver`,
      product: "ns",
    },
    {
      text: "Fixed Rate Saver",
      link: `${window.raeEnv.productPageUrl}/fixed-rate-saver`,
      trackingName: "Fixed Rate Saver",
      product: "frs",
    },
    {
      text: "Help",
      link: `${window.raeEnv.productPageUrl}/help`,
      trackingName: "FAQ Top",
    },
  ];
  
  let disabled =
    (window.location.pathname === "/fixed-rate-saver" &&
      !props.featureEnabled("EnableFRSApplications")) ||
    (window.location.pathname === "/online-flexi-saver" &&
      props.featureEnabled("TurnOffApplications")) || // temporary, remove after released to prod
    (window.location.pathname === "/online-flexi-saver" &&
      !props.featureEnabled("EnableOFSApplications")) ||
    (window.location.pathname === "/notice-saver" &&
      !props.featureEnabled("EnableNSApplications"));

  const goToLink = (/** @type {string} */ link) => () => {
    setMenuOpen(false);
    window.location.href = link;
  };

  const renderLinks = (/** @type {MultiProductHeaderLink[]} */ links) => {
    const addSelected = (/** @type {string} */ path) => path === window.location.pathname;

    return links.map((action, i) =>
      disabled ? null : (
        <li key={i} className={addSelected(action.link) ? "selected" : ""}>
          <a
            className={`header__link${
              addSelected(action.link) ? " header__link--selected" : ""
            }`}
            href={action.link}
            onClick={goToLink(action.link)}
            data-analytics-itemclicked={action.trackingName}
          >
            {action.text}
          </a>
        </li>
      )
    );
  };

  const renderButtonGroupDesktop = () => {
    return (
      <>
        <Button variant="tertiary" 
                size="lrg" 
                label="Log in"
                customClassNames={["button--header"]}
                onClick={goToLink("/login")}
        />
      </>
    );
  };

  const renderProductHeaderLogo = () => {
    return (
      <a href={`${envConfig.links.productPageUrl ? `${envConfig.links.productPageUrl}/` : '/'}`}>
        <div className="header__logo" />
      </a>
    );
  };

  const backgroundColor = '#FFF';
  
  return (
    <header className="header header--product">
      <div className="header__wrapper-p3" style={{backgroundColor: `${backgroundColor}`}}>
        {renderProductHeaderLogo()}
        <div className="header__menus">
          <ul className="primary-nav primary-nav--mobile">
            {window.location.pathname === "/faqs" ||
            window.location.pathname === "/"
              ? renderLinks(primaryActionsFaqs)
              : renderLinks(primaryActions)}
          </ul>
          <ul className="primary-nav primary-nav--desktop">
            {renderLinks(multiSecondaryActions)}
          </ul>
          <ButtonGroup noGutter>
            {renderButtonGroupDesktop()}
          </ButtonGroup>
          <div
            className="header__hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <img src={menuOpen ? closeIcon : hamburgerIcon} />
          </div>
        </div>
      </div>
      <ul className={getSecondaryNavClasses(menuOpen)}>
        {renderLinks(multiSecondaryActions)}
      </ul>
    </header>
  );
};

const getSecondaryNavClasses = (/** @type {boolean} */ menuOpen) =>
  ["header__secondary-nav", menuOpen ? "header__secondary-nav--open" : ""]
    .join(" ")
    .trim();

export default withFeatureFlags(MultiProductHeader);
